// extracted by mini-css-extract-plugin
export default {"captcha":"captcha-nGYX_o","content":"content-cUh1VV"};